export const DataPedi = [
    {
        id: 1,
        image: "/Images/Child/Pediatrics/OP.webp",
        title: "Inpatient and Outpatient Care",
    },
    {
        id: 2,
        image: "/Images/Child/Pediatrics/Day-Care.webp",
        title: "Day Care Treatment",
    },
    {
        id: 3,
        image: "/Images/Child/Pediatrics/Vaccination.webp",
        title: "Pediatric Vaccination Services",
    },
    {
        id: 4,
        image: "/Images/Child/Pediatrics/Nebulization.webp",
        title: "Nebulization therapy",
    },
    {
        id: 5,
        image: "/Images/Child/Pediatrics/Adolescent.webp",
        title: "Adolescent Medicine",
    },  
];
